module.exports = __webpack_public_path__ + "static/media/redMarker.18fe3fed.svg";